module.exports = __webpack_public_path__ + "static/media/delete.87f99940.svg";